import React, { useEffect, useState } from 'react';
import { Button, CircularProgress, Typography, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DataGridPro } from '@mui/x-data-grid-pro';
import apiService from '../../../utlis/apiService';
import { useUser } from '../../../context/userContext';

const EmySchemeList = () => {
    const { permissions } = useUser();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalResults, setTotalResults] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: 50,
        page: 0,
    });
    const pageOption = [10, 25, 50, 100];

    useEffect(() => {
        getData();
    }, [searchTerm, paginationModel]);

    let navigate = useNavigate();

    const getData = async () => {
        setLoading(true); // Set loading to true when fetching data
        try {
            const response = await apiService.get('/emi-scheme/list', {
                params: {
                    searchTerm: searchTerm,
                    page: paginationModel.page,
                    pageSize: paginationModel.pageSize,
                },
            });

            setData(response?.data?.emiScheme);
            setTotalResults(response?.data?.totalResults);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false); // Set loading to false when data fetching is complete
        }
    };

    const deleteItem = (id) => {
        const shouldDelete = window.confirm('Are you sure you want to delete this item?');
        if (shouldDelete) {
            deleteServer(id);
        }
    };

    const deleteServer = async (mid) => {
        try {
            const response = await apiService.post('/emi-scheme/delete', null, {
                params: {
                    id: mid,
                },
            });
            getData();
        } catch (error) {
            console.error(error);
        }
    };

    const createPress = () => {
        navigate('/dashboard/emi-scheme/add');
    };

    return (
        <div>
            <div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex' }}>
                <Typography variant="h4" gutterBottom>
                    EMI SCHEME
                </Typography>
                {permissions.includes('createEmiScheme') && (
                    <Button variant="contained" size='small' color="primary" style={{ marginBottom: '16px' }} onClick={createPress}>
                        + Create
                    </Button>
                )}
            </div>
            <TextField
                label="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                fullWidth
                margin="dense"
                size='small'
                style={{ marginBottom: 10 }}
            />
            {loading ? ( 
                <CircularProgress style={{ margin: '20px auto', display: 'block' }} />
            ) : (
                <div style={{ height: '70vh', width: '100%' }}>
                    <DataGridPro
                        rows={data}
                        getRowId={(row) => row?._id}
                        columns={[
                            { field: 'name', headerName: 'Name', flex: 1 },
                            { field: 'downPayment', headerName: 'Down Payment', flex: 1 },
                            { field: 'additionalCharge', headerName: 'Additional Charge', flex: 1 },
                            { field: 'discount', headerName: 'Discount', flex: 1 },
                            {
                                field: 'actions',
                                headerName: 'Action',
                                flex: 1,
                                renderCell: (params) => (
                                    <>
                                        {permissions.includes('updateEmiScheme') && (
                                            <Button size='small' variant="outlined" onClick={() => navigate(`/dashboard/emi-scheme/add?id=${params.row?._id}`)}>Edit</Button>
                                        )}
                                        {permissions.includes('deleteEmiScheme') && (
                                            <Button size='small' variant="outlined" color="error" style={{ marginLeft: 5 }} onClick={() => deleteItem(params.row?._id)}>Delete</Button>
                                        )}
                                    </>
                                ),
                            },
                        ]}
                        pagination
                        paginationModel={paginationModel}
                        rowCount={totalResults}
                        paginationMode="server"
                        onPaginationModelChange={setPaginationModel}
                        rowsPerPageOptions={pageOption}
                    />
                </div>
            )}
        </div>
    );
};

export default EmySchemeList;
